export const getEndOfDay = (date?: Date) => {
    if (!date) return null
    const d = new Date(date)
    d.setHours(23, 59, 59, 999)
    return d
}
